import React from "react"
import { useAdvancedSearchDSMutation } from "../../core/api/ds-state-api"
import MultiSearch from "./MultiSearch"

export default function SearchBarTOH() {
    return <MultiSearch useSearchHook={useAdvancedSearchDSMutation}/>
}
